<div class="container-fluid">
  <div class="common-padding">
    <div class="alert alert-danger" *ngIf="hasTimeoutError">
      {{ timeoutErrorMessage }}
    </div>
    <div class="alert alert-danger" *ngIf="hasApiError && !hasTimeoutError">
      {{ genericErrorMessage }}
    </div>
    <div class="alert alert-warning" *ngIf="isInvalidView">
      The requested view is not recognised. Showing default view instead.
    </div>

    <!-- Screen reader live region: announces filter state changes -->
    <span class="omni-sr-only" aria-live="polite" aria-atomic="true">{{ filterAnnounceMessage }}</span>

    <div class="heading mt-2">
      <span class="title">{{ activeViewLabel | uppercase }}</span>
      <span class="pt-2" style="font-size: 13px;">
        <a href="assets/userguides/OmnidashboardUserGuide.html" target="_blank" rel="noopener noreferrer" class="pl-3 download-link">User Guide</a>
      </span>
      <button
        *ngIf="!isLoading && !isEmptyResult && ergRows.length > 0"
        type="button"
        class="btn btn-outline-danger omni-export-btn"
        [disabled]="!canExport"
        [title]="!canExport ? strings.exportDisabledTitle : ''"
        (click)="exportToExcel()"
        [attr.aria-label]="strings.exportAriaLabel">
        {{ strings.exportButton }}
      </button>
    </div>
    
    <div class="omni-empty-state" *ngIf="isEmptyResult && !isLoading">
      <i class="fa fa-table omni-empty-icon" aria-hidden="true"></i>
      <p class="noDataFound">{{ strings.emptyTitle }}</p>
      <p class="omni-empty-hint">{{ strings.emptyHint }}</p>
    </div>

    <div class="omni-table-wrapper" *ngIf="isLoading" aria-busy="true" aria-label="Loading matrix">
      <table class="omni-table">
        <thead>
          <tr>
            <th class="omni-corner">&nbsp;</th>
            <th *ngFor="let c of skeletonCols" class="omni-col-header">
              <div class="omni-skeleton-cell"></div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let r of skeletonRows">
            <td class="omni-row-name">
              <div class="omni-skeleton-cell omni-skeleton-name"></div>
            </td>
            <td *ngFor="let c of skeletonCols" class="omni-cell">
              <div class="omni-skeleton-cell"></div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="omni-workspace" *ngIf="!isLoading && !isEmptyResult && ergRows.length > 0">
      <div class="omni-matrix-card omni-matrix-card--flex"
           [class.omni-matrix-card--has-min-height]="!isFilterActive && visibleRows.length > 4">
        <div class="omni-matrix-card__chrome">
          <div class="omni-filter-panel omni-filter-bar" role="region" [attr.aria-label]="strings.filterRegionAria">
            <div class="omni-filter-meta">
              <strong>FY{{ selectedFiscalYear.slice(-2) }}</strong>
              <span class="omni-filter-meta-sep" aria-hidden="true">·</span>
              <span class="omni-filter-meta-primary">{{ activeViewLabel }}</span>
              <span class="omni-filter-meta-sep" aria-hidden="true">·</span>
              <span class="omni-filter-meta-count">{{ filterContextLabel }}</span>
              <span class="omni-filter-meta-sep" *ngIf="isFilterActive" aria-hidden="true">·</span>
              <span class="omni-filter-meta-active" *ngIf="isFilterActive">{{ visibleChapterCount }} chapters available for the filtered view</span>
              <!-- <button
                *ngIf="isFilterActive"
                type="button"
                class="omni-meta-reset"
                [ngbTooltip]="strings.resetFilters"
                placement="bottom"
                container="body"
                (click)="clearFilters()"
                [attr.aria-label]="strings.resetFilters"><i class="fa fa-times" aria-hidden="true"></i></button> -->
            </div>

            <div class="omni-filter-controls">
              <div class="omni-filter-group" [class.omni-filter-group--active]="selectedSiteNames.length > 0">
                <label class="omni-sr-only" for="omni-site-filter">
                  {{ strings.sitesLabel }}
                </label>

                <div class="omni-filter-select-wrap">
                  <ng-select
                    #siteFilter
                    id="omni-site-filter"
                    class="custom omni-filter-select"
                    [class.omni-filter-select--has-values]="selectedSiteNames.length > 0"
                    [items]="siteColumns"
                    bindLabel="siteName"
                    bindValue="siteName"
                    [multiple]="true"
                    [searchable]="true"
                    [closeOnSelect]="false"
                    [clearable]="true"
                    [dropdownPosition]="'auto'"
                    appendTo="body"
                    [placeholder]="strings.sitesPlaceholder"
                    [(ngModel)]="selectedSiteNames"
                    (change)="onFilterChange()"
                    (open)="onSiteFilterOpen()"
                    (close)="onSiteFilterClose()">
                    <ng-template ng-multi-label-tmp let-items="items">
                      <div class="ng-value omni-filter-summary-chip">
                        <span class="ng-value-label">Sites: {{ items.length }} selected</span>
                      </div>
                    </ng-template>
                  </ng-select>
                  <div class="omni-filter-preview" *ngIf="selectedSiteNames.length > 0" role="tooltip">
                    <div class="omni-filter-preview-title">Selected sites</div>
                    <div class="omni-filter-preview-list">
                      <span class="omni-filter-preview-item" *ngFor="let siteName of selectedSiteNames">
                        {{ siteName }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="omni-filter-group" [class.omni-filter-group--active]="selectedErgNames.length > 0">
                <label class="omni-sr-only" for="omni-erg-filter">
                  {{ strings.ergsLabel }}
                </label>

                <div class="omni-filter-select-wrap">
                  <ng-select
                    #ergFilter
                    id="omni-erg-filter"
                    class="custom omni-filter-select"
                    [class.omni-filter-select--has-values]="selectedErgNames.length > 0"
                    [items]="ergRows"
                    bindLabel="bpgName"
                    bindValue="bpgName"
                    [multiple]="true"
                    [searchable]="true"
                    [closeOnSelect]="false"
                    [clearable]="true"
                    [dropdownPosition]="'auto'"
                    appendTo="body"
                    [placeholder]="strings.ergsPlaceholder"
                    [(ngModel)]="selectedErgNames"
                    (change)="onFilterChange()"
                    (open)="onErgFilterOpen()"
                    (close)="onErgFilterClose()">
                    <ng-template ng-multi-label-tmp let-items="items">
                      <div class="ng-value omni-filter-summary-chip">
                        <span class="ng-value-label">ERGs: {{ items.length }} selected</span>
                      </div>
                    </ng-template>
                  </ng-select>
                  <div class="omni-filter-preview" *ngIf="selectedErgNames.length > 0" role="tooltip">
                    <div class="omni-filter-preview-title">Selected ERGs</div>
                    <div class="omni-filter-preview-list">
                      <span class="omni-filter-preview-item" *ngFor="let ergName of selectedErgNames">
                        {{ ergName }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <!-- Lazy metric fetch: body dims via omni-matrix-card__body--loading -->
        <div
          class="omni-matrix-card__body"
          [class.omni-matrix-card__body--loading]="isMetricLoading"
          [attr.aria-busy]="isMetricLoading ? 'true' : null">
          <div class="omni-filter-empty" *ngIf="hasNoVisibleMatrix">
            <p class="omni-filter-empty-title">{{ strings.filterEmptyTitle }}</p>
            <p class="omni-filter-empty-hint">{{ strings.filterEmptyHint }}</p>
            <button type="button" class="btn btn-outline-danger" (click)="clearFilters()">
              {{ strings.resetFilters }}
            </button>
          </div>

          <div class="omni-table-wrapper omni-table-wrapper--labeled" *ngIf="canShowMatrix">
            <table
              class="omni-table"
              role="grid"
              [attr.aria-label]="gridAriaLabel"
              [attr.aria-rowcount]="visibleRows.length"
              [attr.aria-colcount]="visibleSiteColumns.length">
              <thead>
                <tr>
                  <th class="omni-corner">
                    <span class="omni-corner-label">{{ strings.cornerLabel }}</span>
                    <span class="omni-corner-counts">
                      {{ visibleErgRows.length }}&times;{{ visibleSiteColumns.length }}
                      <span *ngIf="isFilterActive">
                        (of {{ ergRows.length }}&times;{{ siteColumns.length }})
                      </span>
                    </span>
                  </th>
                  <th
                    *ngFor="let site of visibleSiteColumns; let j = index; trackBy: trackSite"
                    scope="col"
                    class="omni-col-header"
                    [class.omni-col-highlight]="hoveredColIndex === j"
                    [title]="site.siteName">
                    {{ site.siteName }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of visibleRows; let i = index; trackBy: trackVisibleRow">
                  <th scope="row" class="omni-row-name" [title]="row.erg.bpgName">{{ row.erg.bpgName }}</th>
                  <td
                    *ngFor="let item of row.cells; let j = index; trackBy: trackVisibleCell"
                    [style.backgroundColor]="item.resolved.bg"
                    [style.color]="item.resolved.text"
                    [class.omni-cell-na]="!item.cell.chapterId"
                    [class.omni-cell-intense]="shouldIntensifyCell(item.cell)"
                    [class.omni-cell-muted]="shouldMuteCell(item.cell)"
                    [class.omni-cell-blanked]="shouldBlankCell(item.cell)"
                    [class.omni-cell-flash]="highlightedCellKey === item.key"
                    [title]="item.resolved.tooltip"
                    [attr.tabindex]="item.cell.chapterId ? 0 : null"
                    [attr.aria-label]="item.resolved.tooltip"
                    [attr.aria-disabled]="!item.cell.chapterId"
                    [attr.aria-rowindex]="i + 1"
                    [attr.aria-colindex]="j + 1"
                    [attr.data-omni-cell]="i + '-' + j"
                    (click)="onCellClick(item.cell)"
                    (mouseenter)="onCellHover(j)"
                    (mouseleave)="onCellHover(-1)"
                    (keydown)="onCellKeydown($event, i, j, item.cell)"
                    class="omni-cell">
                    <i *ngIf="item.cell.chapterId; else naText" class="fa {{ item.resolved.displayValue }}" aria-hidden="true"></i>
                    <ng-template #naText>{{ item.resolved.displayValue }}</ng-template>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="omni-matrix-card__footer" *ngIf="showSummary">
          <div class="omni-summary">
            <div class="omni-summary-counts">
              <span class="summary-total">{{ summaryTotalLabel }}</span>
              <button
                *ngFor="let entry of summary"
                type="button"
                [style.backgroundColor]="entry.bg"
                [style.color]="entry.text"
                [class.na-summary]="entry.value === summaryNaValue"
                [class.summary-chip--active]="isSummaryActive(entry)"
                [title]="entry.tooltip"
                [attr.aria-pressed]="isSummaryActive(entry)"
                (click)="onSummaryClick(entry)"
                class="summary-chip">
                <i class="fa {{ entry.iconClass }} summary-chip__icon" aria-hidden="true"></i>{{ entry.label }}: {{ entry.count }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
